import React from "react";
import { Grid } from "@mui/material";
import "../../styles/new_design.scss";
import HeaderUtah from "../../components/ui/header/HeaderUtah";
// import InsideDesign from "../../components/newDesign";
import { Box } from "@mui/material";
import CustomDemosDesign from "./customDemosContent";
const CustomDemos: React.FC = () => {
  return (
    <Grid className="approot new_design">
      <HeaderUtah />
      <Box sx={{ padding: "0px !important" }}>
        <Box className="customTabcontent" sx={{ padding: "0px !important" }}>
          <CustomDemosDesign/>
        </Box>
      </Box>
    </Grid>
  );
};
export default CustomDemos;
